<template>
  <ButtonTooltip
    color="primary"
    small
    :text="!reportStore.showGlobalFilters"
    :icon-name="
      reportStore.showGlobalFilters ? 'fa-filter' : 'fa-filter-circle-xmark'
    "
    :tooltip-text="
      reportStore.showGlobalFilters ? 'Hide Filters' : 'Show Filters'
    "
    :tooltip-props="{ 'nudge-bottom': 8 }"
    button-text-right="filters"
    @click="reportStore.showGlobalFilters = !reportStore.showGlobalFilters"
  />
</template>

<script>
import Vue from "vue"
import { mapStores } from "pinia"
import { useReportStore } from "@/stores/report"
import ButtonTooltip from "@evercam/shared/components/ButtonTooltip.vue"

export default Vue.extend({
  name: "ReportGlobalFiltersBtn",
  components: { ButtonTooltip },
  computed: {
    ...mapStores(useReportStore),
  },
})
</script>
